export const financeOverrideTypes = {
  balance: "Balance Override",
  interest: "Interest Payment Override",
  principal: "Principal Payment Override"
};
